<div class="flex gap-1 whitespace-nowrap" [title]="getTooltip()">
    <span>{{ label | translate }}:</span>
    <span class="truncate font-bold">{{ value }}</span>
</div>
